export const NAME = "FACILITY";
export const SET_FACILITYID = `${NAME}/SET_FACILITYID`;
export const DELETE_FACILITYID = `${NAME}/DELETE_FACILITYID`;
export const GET_FACILITY_SUCCESS = `${NAME}/GET_FACILITY_SUCCESS`;
export const GET_FACILITY = `${NAME}/GET_FACILITY`;
export function setFacilityId(id) {
  return {
    type: SET_FACILITYID,
    id
  };
}

export function deleteFacilityId() {
  return {
    type: DELETE_FACILITYID
  };
}

export function getFacilityData(data) {
  return {
    type: GET_FACILITY,
    data
  };
}

export function getFacilitySuccess(data) {
  return {
    type: GET_FACILITY_SUCCESS,
    data
  };
}



// WEBPACK FOOTER //
// ./src/redux/facility/actions.js